import _ from 'lodash';
import {all, takeLatest, put} from 'redux-saga/effects';
import {startSubmit, stopSubmit} from 'redux-form';

import {request, createFetchSagaLatest} from 'utils/sagas';

import {
  fetchInvoicesForReporting as fetchInvoicesForReportingAction,
  INITIATE_GO_CARDLESS_PAYMENTS_FLOW,
  MODALS,
  updateSelectedInvoicesForPaymentInitiation,
  PREVIEW_INVOICES_FOR_PAYMENT_INITIATION,
  previewInvoicesForPaymentInitiationSuccess,
  previewInvoicesForPaymentInitiationFailure,
  BULK_INITIATE_GO_CARDLESS_PAYMENTS,
  bulkInitiateGoCardlessPaymentsSuccess,
  bulkInitiateGoCardlessPaymentsFailure
} from './';

import {
  openModal,
  storeDataInModal,
  MODALS as BASE_MODALS,
  closeModal
} from 'ducks/modals';

import {
  fetchInvoicesForReporting,
  fetchExcludedInvoicesFromPaymentInitiation,
  previewInvoicesForPaymentInitiation,
  bulkInitiateGoCardlessPayments
} from 'sdk/reporting';

function* initiateGoCardlessPaymentsFlowWorker(action) {
  const {invoicesIds} = action.payload;

  yield put(updateSelectedInvoicesForPaymentInitiation({invoicesIds}));

  const {data} = yield request(fetchExcludedInvoicesFromPaymentInitiation, {
    invoicesIds
  });

  if (!_.isEmpty(data)) {
    yield put(
      openModal(MODALS.EXCLUDED_INVOICES_FROM_PAYMENT_INITIATION, {
        invoices: data
      })
    );
  } else {
    yield put(openModal(MODALS.PREVIEW_INVOICES_FOR_PAYMENT_INITIATION));
  }
}

function* previewInvoicesForPaymentInitiationWorker(action) {
  const {invoicesIds, extraActions} = action.payload;

  yield put(
    storeDataInModal({
      modalName: MODALS.PREVIEW_INVOICES_FOR_PAYMENT_INITIATION,
      data: {
        isLoading: true
      }
    })
  );

  const {data, errors} = yield request(previewInvoicesForPaymentInitiation, {
    invoicesIds
  });

  if (data) {
    yield put(previewInvoicesForPaymentInitiationSuccess(data));
    yield* extraActions.map(a => put(a(data)));
  } else {
    yield put(previewInvoicesForPaymentInitiationFailure(errors));
  }

  yield put(
    storeDataInModal({
      modalName: MODALS.PREVIEW_INVOICES_FOR_PAYMENT_INITIATION,
      data: {
        isLoading: false
      }
    })
  );
}

function* bulkInitiateGoCardlessPaymentsWorker(action) {
  const {
    invoicesIds,
    specifiedDesiredPaymentDate,
    takePaymentAtEarliestChargeDate,
    extraActions
  } = action.payload;

  yield put(startSubmit('bulkInitiateGoCardlessPaymentsForm'));

  const {data, errors} = yield request(bulkInitiateGoCardlessPayments, {
    invoicesIds,
    specifiedDesiredPaymentDate,
    takePaymentAtEarliestChargeDate
  });

  if (data) {
    yield put(bulkInitiateGoCardlessPaymentsSuccess(data));
    yield put(stopSubmit('bulkInitiateGoCardlessPaymentsForm'));

    yield* extraActions.map(a => put(a(data)));
  } else {
    yield put(bulkInitiateGoCardlessPaymentsFailure(errors));

    yield put(closeModal(BASE_MODALS.CONFIRM));

    yield put(stopSubmit('bulkInitiateGoCardlessPaymentsForm', errors));
  }
}

function* invoiceReportingSaga() {
  yield all([
    createFetchSagaLatest(
      fetchInvoicesForReportingAction,
      fetchInvoicesForReporting
    ),
    takeLatest(
      INITIATE_GO_CARDLESS_PAYMENTS_FLOW,
      initiateGoCardlessPaymentsFlowWorker
    ),
    takeLatest(
      PREVIEW_INVOICES_FOR_PAYMENT_INITIATION,
      previewInvoicesForPaymentInitiationWorker
    ),
    takeLatest(
      BULK_INITIATE_GO_CARDLESS_PAYMENTS,
      bulkInitiateGoCardlessPaymentsWorker
    )
  ]);
}

export default invoiceReportingSaga;
